<template>
  <div class="guidance-container"> 
    <h1 style="font-weight: bold;text-align: center">机构认证</h1>
    <div style="font-size: 14px;color: #999;text-align: center">您的账号尚未进行机构认证</div>
    <div class="fragment">认证成功可解锁更多功能，并获取<span style="color:#e75934;">180</span>天校外访问权限</div>

    <div class="content">
      <div class="img">
        <img src="../../assets/img/go_guidance.png" alt="" />
      </div>
    </div>
    <div class="btns">
      <router-link to="/attestation" class="ant-btn ant-btn-primary">立即前往</router-link>
      <a href="javascript:;" @click="nextTime" class="ant-btn">下次再说</a>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import { useRouter } from "vue-router";
import { delCookie, getCookie } from "../../until/tools";

  export default defineComponent({
    setup() {
      const router = useRouter();
      const nextTime = ()=>{
        let locationTarget = getCookie("locationTarget");
        if (locationTarget) {
          delCookie("locationTarget");
          window.location.href = locationTarget;
        } else {
          router.push("/index");
        }
      }
      onMounted(()=> {
        let isNewReg = getCookie('isNewReg');
        if(isNewReg) {
          delCookie('isNewReg');
          window.location.reload();
        }
      })

      return {
        nextTime
      }
    }
  })
</script>

<style lang="scss" scoped>
.guidance-container{
  width: 440px;
    height: 700px;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
  .fragment{
    text-align: center;
    margin-top: 18px;
  }
.content {
  text-align: center;
  margin-top: 55px;
  overflow: hidden;
  .go_guidance{
    font-weight: bold;
    text-align: left
  }
}
.btns{
  margin-top: 60px;
  /deep/.ant-btn:hover, /deep/.ant-btn:focus,.ant-btn{
    border:none
}
  a{
    display: block;
    width: 225px;
    height: 44px;
    line-height: 44px;
    margin-left: 25%;
    margin-bottom:20px;
  }
  a:first-child{
    background: #2c3032 !important;
    border: none;
    font-size:16px
  }
  a:last-child{
    background: #CBCBCB;
    font-size:16px;
    color: #fff;
  }
}
</style>